var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.3,13.974a.781.781,0,0,0-1.448.585l.92,2.275-2.731-1.2a.78.78,0,0,0-.621,0,7.534,7.534,0,0,1-2.972.6A6.763,6.763,0,0,1,6.457,9.9c0-3.49,3.135-6.329,6.987-6.329S20.431,6.408,20.431,9.9a6.382,6.382,0,0,1-.069.894.781.781,0,1,0,1.544.23A7.851,7.851,0,0,0,21.992,9.9a7.546,7.546,0,0,0-2.528-5.6,8.872,8.872,0,0,0-6.02-2.287A8.87,8.87,0,0,0,7.425,4.3a7.58,7.58,0,0,0-2.5,4.931A6.311,6.311,0,0,0,2.008,14.48a6.058,6.058,0,0,0,1.2,3.619l-1.141,2.82a.781.781,0,0,0,.724,1.073.771.771,0,0,0,.315-.066l3.288-1.449a7.425,7.425,0,0,0,2.6.464c.02,0,.039,0,.058,0a7.4,7.4,0,0,0,3.673-1,6.72,6.72,0,0,0,2.362-2.3,8.952,8.952,0,0,0,1.622-.451L20.9,19.038a.781.781,0,0,0,1.039-1.007Zm-11.3,5.4-.031,0a5.852,5.852,0,0,1-2.281-.467.784.784,0,0,0-.621,0l-1.828.806.589-1.459a.782.782,0,0,0-.129-.8A4.55,4.55,0,0,1,3.569,14.48a4.645,4.645,0,0,1,1.443-3.326,7.88,7.88,0,0,0,2.309,4.22,8.729,8.729,0,0,0,5.68,2.4A5.742,5.742,0,0,1,8.994,19.377Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.405,
    cy: 9.931,
    r: 0.781
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.528,
    cy: 9.931,
    r: 0.781
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.283,
    cy: 9.931,
    r: 0.781
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.e6e191299b50bdb239c03afa3c1848ff.svg";
export { ForwardRef as ReactComponent };